import type { RouteObject } from "react-router-dom";

import { ponziRoutes } from "./ponzi/routes";

export const gamblingMechanicsRoutes: Array<RouteObject> = [...ponziRoutes];
